import React from "react"
import { Field, ErrorMessage, getIn } from "formik"
import ErrorPopUp from '../../Shared/ErrorPopUp'
import { AsyncUnitSelect } from '../../Shared/AsyncUnitSelect'
import { NumberInput } from 'react-hichestan-numberinput'

export default ({ touched, errors, setFieldValue, values, handleBlur }) => (
  <div className="row display-flex">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">

      <fieldset className="fieldset">
        <legend>توضیحات</legend>

        <div className="row">
          <div className="form-inline">

            {/* <div className="col-md-6 col-sm-12">
              <label>تعداد ورق پرس شده سالم</label>
              <NumberInput type='tel'
                // autoFocus
                value={values.quantity}
                onChange={e => {
                  setFieldValue("quantity", e.target.value)
                }}
                className="text-input"
              />
              <ErrorMessage component={ErrorPopUp} name="quantity" />
            </div>

            <div className="col-md-6 col-sm-12">
              <label>تعداد ضایعات</label>
              <NumberInput type='tel'
                value={values.waste}
                maxLength={values.waste}
                onChange={e => {
                  setFieldValue("waste", e.target.value)
                }}
                className="text-input"
              />
              <ErrorMessage component={ErrorPopUp} name="waste" />
            </div> */}

            <div className="col-md-12 col-sm-12">
              {/* <label>توضیحات</label> */}
              <Field name="description" rows="2"
                render={({ field }) =>
                  <textarea {...field}
                    value={values.description || ''}
                    className="textarea rtl"
                  />}
              />
            </div>
          </div>
        </div>



      </fieldset>

    </div>

  </div>
);